class ProductVideoControls extends HTMLElement {
  constructor() {
    super();

    this.config = {
      selectors: {
        videoContainer: '.product-single__video',
        video: 'video',
      },
      classes: {
        container: 'product-video-container',
        control: 'product-video__control',
        pauseIcon: 'product-video__pause-icon',
        playIcon: 'product-video__play-icon',
        paused: 'paused',
      },
      breakpoints: {
        mobile: 767,
      },
    };
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const videoContainers = document.querySelectorAll(this.config.selectors.videoContainer);

    if (!videoContainers.length) return;

    videoContainers.forEach((container) => this.setupVideoControls(container));
  }

  // Video Controls are set up dynamically due to complexity of product-media.liquid set up - would be good to refactor in the future.
  setupVideoControls(container) {
    const video = container.querySelector(this.config.selectors.video);
    if (!video) return;

    container.classList.add(this.config.classes.container);
    const controlButton = this.createControlButton();
    container.appendChild(controlButton);

    this.setupEventListeners(video, container, controlButton);
    this.initializeAutoplay(video);
  }

  createControlButton() {
    const button = document.createElement('div');
    button.className = this.config.classes.control;

    button.innerHTML = `
      <svg class="${this.config.classes.pauseIcon}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="4" width="4" height="16" fill="currentColor"/>
        <rect x="14" y="4" width="4" height="16" fill="currentColor"/>
      </svg>
      <svg class="${this.config.classes.playIcon}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 5v14l11-7z" fill="currentColor"/>
      </svg>
    `;

    return button;
  }

  setupEventListeners(video, container, controlButton) {
    const mobileQuery = window.matchMedia(`(max-width: ${this.config.breakpoints.mobile}px)`);

    video.addEventListener('click', (e) => {
      if (mobileQuery.matches) {
        this.togglePlayPause(video, container);
        e.preventDefault();
      }
    });

    controlButton.addEventListener('click', (e) => {
      this.togglePlayPause(video, container);
      e.stopPropagation();
    });
  }

  initializeAutoplay(video) {
    if (video.hasAttribute('autoplay')) {
      video.muted = true;
      video.play().catch((error) => {
        console.log('Video autoplay failed:', error);
      });
    }
  }

  togglePlayPause(video, container) {
    if (video.paused) {
      video.play();
      container.classList.remove(this.config.classes.paused);
    } else {
      video.pause();
      container.classList.add(this.config.classes.paused);
    }
  }
}

// Define the custom element
customElements.define('product-video-controls', ProductVideoControls);
